import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { ScreenType } from '@fgb/core';
import { distinctUntilChanged, fromEvent, map, startWith } from 'rxjs';

@Component({
  selector: 'fgb-rewards-layout',
  templateUrl: './rewards-layout.component.html',
  styleUrls: ['./rewards-layout.component.scss'],
})
export class RewardsLayoutComponent implements OnInit, AfterViewInit {
  screenType = ScreenType;
  title: string = '';
  showHeader: boolean = false;
  showPoints: boolean = false;
  isMobileNavDisabled: boolean = false;
  showMobileHeader: boolean = false;
  showQrCode: boolean = false;
  mobileTitle: string = '';
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private cd = inject(ChangeDetectorRef);

  constructor() {}
  ngOnInit() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._init();
        this._checkMobileNavVisibility();
      }
    });

    fromEvent(window, 'resize')
      .pipe(
        startWith(window.innerWidth < 992),
        map(() => window.innerWidth < 992),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this._checkMobileNavVisibility();
      });
  }

  ngAfterViewInit(): void {
    this._init();
  }

  private _init(): void {
    this._checkHeaderVisibility();
    this._getMobileTitle();
    this.cd.detectChanges();
  }

  private _checkMobileNavVisibility(): void {
    const disabledMobileNav: string[] = ['wallet'];
    this.isMobileNavDisabled = disabledMobileNav.some((path) => this.router.url.includes(path)) && window.innerWidth < 992;
  }

  private _checkHeaderVisibility(): void {
    const hiddenHeader: string[] = ['details', 'purchase', 'claimed'];
    const showMobileHeaderRoutes: string[] = ['success'];
    this.showHeader = !hiddenHeader.some((path) => this.router.url.includes(path));
    this.showMobileHeader = showMobileHeaderRoutes.some((path) => this.router.url.includes(path));

    const walletUrl: string[] = ['wallet'];
    this.showPoints = !walletUrl.some((path) => this.router.url.includes(path));
    this.showQrCode = walletUrl.some((path) => this.router.url.includes(path));
  }

  private _getMobileTitle(): void {
    const rewardTitles = ['marketplace', 'auctions', 'raffles'];
    const walletTitles = ['wallet'];
    if (rewardTitles.some((title) => this.router.url.includes(title))) {
      this.mobileTitle = 'rewards.page.title';
    } else if (walletTitles.some((title) => this.router.url.includes(title))) {
      this.mobileTitle = 'wallet.page.title';
    }
  }
}
